import React, { useEffect, useRef } from 'react';
import { connect } from "react-redux";
import PropTypes from "prop-types";
import moment from 'moment';
import 'moment/locale/fr';
import Select from 'react-select';
import { isAfter, isBefore, parse } from 'date-fns';
import { withRouter } from "react-router-dom";
import ApexCharts from 'apexcharts';
import { getReportingChart, exportReporting } from "../../../redux/actions/admin/ReportingActions";
import ReactLoading from "react-loading";

const ref = React.createRef();



let Reporting = (props) => {
    const {
        getReportingChart,
        storeReporting = {},
        exportReporting,
        reporting = {}
    } = props;

    const selectInputRef = React.useRef();
    const [canAddFilterOption, setCanAddFilterOption] = React.useState(false);
    const [applications, setApplications] = React.useState([]);
    const [hasAdditionalQuestions, setHasAdditionalQuestions] = React.useState(false);
    const [additionalQuestions, setAdditionalQuestions] = React.useState([]);
    const [searchResult, setSearchResult] = React.useState([]);
    const [filterOptions, setFilterOptions] = React.useState([]);
    const [data, setData] = React.useState([]);
    const [months, setMonths] = React.useState([]);
    const [categories, setCategories] = React.useState([]);
    const [tiles, setTiles] = React.useState([]);
    const [isLoading, setIsLoading] = React.useState(true);
    const [selectedfilterOptions, setSelectedFilterOptions] = React.useState(
        [
            { label: "", type: "", required: false, value: "", optionsValue: [], id: "", selectedOperator: "", operators: [] }
        ]
    );
    const [selectedEntity, setSelectedEntity] = React.useState('employers');
    const [selectedYear, setSelectedYear] = React.useState(null);
    const [selectedIsActive, setSelectedIsActive] = React.useState(null);
    const closeExportReportingsModal = React.useRef();

    const chartRef = useRef(null);
    const chartInstance = useRef(null);
    const total = data.reduce((sum, item) => sum + item, 0);



    const downloadReporting = async () => {
    try {
        const response = await exportReporting(
            selectedEntity,
            selectedYear === "all" ? null : selectedYear,
            selectedIsActive
        );

        closeExportReportingsModal.current?.click();

        if (response?.url) {
            window.open(response.url, "_blank");
        }
    } catch (error) {
        console.error(error);
        closeExportReportingsModal.current?.click();
    }
    };

    useEffect(() => {
        console.log('reporting', storeReporting)
        if (storeReporting.reportingChartData?.length === 0) {
            getReportingChart("employers").then(resp => {

                const months = [...new Set(resp.map(item => item.month))];
                const values = resp.map(item => Number(item.value) || 0);
                console.log('values', values)
                setData(values);
                setMonths(months)
            });
        }
        else if (storeReporting.reportingChartData?.length > 0) {
            const values = storeReporting.reportingChartData.map(item => item.value);
            const months = storeReporting.reportingChartData.map(item => item.month);
            setData(values);
            setMonths(months)           
        }

    }, []);

    useEffect(() => {
        if (data.length > 0 && months.length > 0) {
            initializeChart();
        }
    }, [data, months])

    let initializeChart = () => {
        if (chartInstance.current) {
            chartInstance.current.destroy(); 
        }

        var options = {
            chart: {
                height: 800,
                type: 'bar',
                toolbar: {
                    show: false,
                },
            },
            plotOptions: {
                bar: {
                    barHeight: '40%',
                    vertical: true,
                }
            },
            legend: {
                show: true,
                position: "top",
                containerMargin: {
                    top: -10
                }
            },
            grid: {
                show: true,
                borderColor: '#ebedf2',
            },
            colors: ['#21c87a'],
            dataLabels: {
                enabled: true
            },
            series: [{
                data: data 
            }],
            xaxis: {
                categories: months, 
                axisBorder: {
                    show: false,
                }
            },

            responsive: [{
                breakpoint: 800,
                options: {
                    chart: {
                        height: 800,
                        type: 'bar',
                        toolbar: {
                            show: false,
                        },
                    },
                    plotOptions: {
                        bar: {
                            horizontal: true,
                        }
                    },
                },
            }]
        }

        chartInstance.current = new ApexCharts(
            chartRef.current,
            options
        );

        chartInstance.current.render();
    };

    useEffect(() => {
        disabledOptions();
        handleCanAddFilterOption();
    }, [selectedfilterOptions]);

    const disabledOptions = () => {
        let options = [...filterOptions];
        options.forEach(element => {
            if (selectedfilterOptions.some(f => f.id == element.value)) {
                let indexOf = options.findIndex(o => o.value == element.value);
                if (indexOf > -1) {
                    options[indexOf].isDisabled = true;
                }

            }
            else {
                let indexOf = options.findIndex(o => o.value == element.value);
                if (indexOf > -1) {
                    options[indexOf].isDisabled = false;
                }
            }
        });
        // setFilterOptions(options);
    }
    const handleCanAddFilterOption = () => {
        if (selectedfilterOptions?.some(f => f.id == "" || f.value == "")) {
            setCanAddFilterOption(false);
        }
        else {
            setCanAddFilterOption(true);
        }
    }

useEffect(() => {
    setIsLoading(true);

    getReportingChart(
        selectedEntity,
        selectedYear,
        selectedIsActive
    )
        .then(resp => {
            const months = [...new Set(resp?.map(item => item.month))];
            const values = resp?.map(item => Number(item.value) || 0);
            setData(values);
            setMonths(months);
        })
        .finally(() => {
            setIsLoading(false);
        });

}, [selectedEntity, selectedYear, selectedIsActive]);



    useEffect(() => {
        return () => {
            if (chartInstance.current) {
                chartInstance.current.destroy();
            }
        };
    }, []);


    const EntityOptions = [
        { label: "Employeurs", value: "employers" },
        { label: "Candidates", value: "candidates" },
        { label: "Offres d'emploi", value: "jobs" },
        { label: "Appel d'offres", value: "tenders" }
    ]


    const stateOptions = [
        { label: "Tout", value: null },
        { label: "Actif", value: true },
        { label: "Inactif", value: false }
    ]

    const currentYear = new Date().getFullYear();
    const yearOptions = [
        { label: "Toutes", value: "all" },
        ...Array.from(
            { length: currentYear - 2015 + 1 },
            (_, index) => {
                const year = currentYear - index;

                return {
                    label: year.toString(),
                    value: year.toString()
                };
            }
        )
    ];

    return (
        <>
            <div className="bg-white pt-4 mt-lg-0 mb-4 mx-0">
                <div className="col-lg-9">
                    <h2 className="title" style={{ marginLeft: "10px", marginTop: "0px" }}><span>Rapports</span></h2>
                </div>
                {/* Filtre */}
                <div className="row">
                    <div className="col-5">
                        <div className="form-row p-3">
                            <div className="form-group col-md-12">
                                <label>Entité</label>
                                <Select
                                    options={EntityOptions}
                                    defaultValue={EntityOptions.find(opt => opt.value === "employers")}
                                    loadingMessage="En cours de chargement"
                                    onChange={(O) => setSelectedEntity(O.value)}
                                />

                            </div>
                        </div>
                    </div>
                    <div className="col-7">
                        <div className="form-row p-3 justify-content-end">
                            <div className="form-group col-md-5">
                                <label>Années</label>
                                <Select
                                    options={yearOptions}
                                    defaultValue={yearOptions.find(opt => opt.value === "all")}
                                    loadingMessage="En cours de chargement"
                                    onChange={(O) => setSelectedYear(O.value)}
                                />
                            </div>
                            <div className="form-group col-md-5">
                                <label>Status</label>
                                <Select
                                    options={stateOptions}
                                    defaultValue={stateOptions.find(opt => opt.value === null)}
                                    loadingMessage="En cours de chargement"
                                    onChange={(O) => setSelectedIsActive(O.value)}
                                />
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            {/* Line Chart */}
            {(data?.length > 0) && (
                <div className="row">
                    <div className="col-md-12">
                        <div className="user-dashboard-info-box bg-white shadow-sm p-4 pb-0">
                            <div className="row">
                                <div className="col-lg-6">
                                    <h2 className="title" style={{ marginLeft: "10px", marginTop: "0px" }}><span>Total: {total}</span></h2>
                                </div>

                                <div
                                    className="col-lg-6"
                                    style={{ textAlign: "right", marginTop: "30px" }}
                                >                                  
                                    <a
                                        href="#"
                                        className="text-primary"
                                        title="Télécharger les statistiques"
                                        data-toggle="modal"
                                        data-target="#exportReporting"
                                        onClick={downloadReporting}
                                    >
                                        <i className="fa fa-download fa-1-5x"></i>
                                    </a>
                                </div>
                            </div>
                            <div
                                style={{
                                    position: "relative",
                                    minHeight: "500px"
                                }}
                            >
                            {isLoading && (
                                <div
                                    style={{
                                        position: "absolute",
                                        top: 0,
                                        left: 0,
                                        width: "100%",
                                        height: "100%",
                                        backgroundColor: "rgba(255,255,255,0.6)",
                                        display: "flex",
                                        justifyContent: "center",
                                        alignItems: "center",
                                        zIndex: 999
                                    }}
                                >
                                    <ReactLoading
                                        type="bubbles"
                                        color="#007cb5"
                                        height={80}
                                        width={80}
                                    />
                                </div>
                            )}

                            <div
                                style={{
                                    position: "relative",
                                    minHeight: "500px"
                                }}
                            >
                            {isLoading && (
                                <div
                                    style={{
                                        position: "absolute",
                                        top: 0,
                                        left: 0,
                                        width: "100%",
                                        height: "100%",
                                        backgroundColor: "rgba(255,255,255,0.6)",
                                        display: "flex",
                                        justifyContent: "center",
                                        alignItems: "center",
                                        zIndex: 999
                                    }}
                                >
                                    <ReactLoading
                                        type="bubbles"
                                        color="#007cb5"
                                        height={80}
                                        width={80}
                                    />
                                </div>
                            )}

                                <div ref={chartRef}></div>
                            </div>
                        </div>
                    </div>
                    </div>
                </div>
            )}
            {/* Start Export reporting modale */}
            <div className="modal fade mt-5" id="exportReporting" tabIndex="-1" role="dialog" aria-modal="true">
                <div className="modal-dialog modal-dialog-centered modal-md" role="document">
                    <div className="modal-content">
                        <div className="modal-header p-4" hidden>
                            <button
                                ref={closeExportReportingsModal}
                                type="button"
                                className="close"
                                data-dismiss="modal"
                                aria-label="Close">
                                <span aria-hidden="true">&times;</span>
                            </button>
                        </div>

                        <div className="mt-2">
                            <div className="modal-body">
                                <div ref={ref}>
                                    <div className="container">
                                        <div className="row align-items-center justify-content-center">
                                            <div className="col-">
                                                <h4>
                                                    Téléchargement en cours
                                                </h4>
                                            </div>
                                            <div className="col-2">
                                                <ReactLoading type="bubbles" color="#007cb5" />
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            {/* End Export reporting modale */}
        </>
    )


}

Reporting.propTypes = {
    getReportingChart: PropTypes.func.isRequired,
    storeReporting: PropTypes.object.isRequired,
    jobApplicationDetails: PropTypes.object.isRequired,
    exportReporting: PropTypes.func.isRequired,
};

const mapStateToProps = state => ({
    getReportingChart: PropTypes.func.isRequired,
    storeReporting: state.reporting,
    exportReporting: PropTypes.func.isRequired,
});

export default withRouter(connect(mapStateToProps, {
    getReportingChart, exportReporting
})
    (Reporting));